"use client";

import { Button } from "@/src/components/Button";
import { CheckBox } from "@/src/components/Fields/CheckBox";
import { CheckBoxProps } from "@/src/components/Fields/CheckBox/lib/type";
import { DatePickerField } from "@/src/components/Fields/DataPickerField";
import { DatePickerFieldProps } from "@/src/components/Fields/DataPickerField/lib/type";
import { NumberField } from "@/src/components/Fields/NumberField";
import { NumberFieldProps } from "@/src/components/Fields/NumberField/lib/type";
import { PhoneField } from "@/src/components/Fields/PhoneField";
import { PhoneFieldProps } from "@/src/components/Fields/PhoneField/lib/type";
import { SelectCounterField } from "@/src/components/Fields/SelectCounterField";
import { SelectCounterFieldProps } from "@/src/components/Fields/SelectCounterField/lib/type";
import { SelectField } from "@/src/components/Fields/SelectField";
import { SelectFieldProps } from "@/src/components/Fields/SelectField/lib/type";
import { TextField } from "@/src/components/Fields/TextField";
import { TextFieldProps } from "@/src/components/Fields/TextField/lib/type";
import { withFieldHint } from "@/src/components/HighOrderComponents";
import { InjectedFieldHintProps } from "@/src/components/HighOrderComponents/lib/type";
import {
  Container,
  Stack,
} from "@mui/material";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { AutoNumberFieldProps } from "@/src/components/Fields/AutoNumberField/lib/type";
import { useContextStore } from "@/src/stores/useContextStore";
import { ProposalTable } from "@/src/components/ProposalTable";

const TextFieldWithHint = withFieldHint<
  TextFieldProps<any> & InjectedFieldHintProps
>(TextField);
const DatePickerWithHint = withFieldHint<
  DatePickerFieldProps<any> & InjectedFieldHintProps
>(DatePickerField);
const SelectCounterWithHint = withFieldHint<
  SelectCounterFieldProps<any> & InjectedFieldHintProps
>(SelectCounterField);
const SelectWithHint = withFieldHint<
  SelectFieldProps<any> & InjectedFieldHintProps
>(SelectField);
const PhoneFieldWithHint = withFieldHint<
  PhoneFieldProps<any> & InjectedFieldHintProps
>(PhoneField);
const CheckBoxWithHint = withFieldHint<
  CheckBoxProps<any> & InjectedFieldHintProps
>(CheckBox);
const NumberFieldWithHint = withFieldHint<
  NumberFieldProps<any> & InjectedFieldHintProps
>(NumberField);

const items = [
  {
    name: "Додаткове покриття на 100 000 грн",
    context: ["name", "dateOfCreation"],
    editable: true,
  },
  {
    name: "Дата початку дії полісу",
    context: ["dateOfLaunch"],
    editable: true,
  },
  { name: "Номер авто", context: ["autoNumber"], editable: true },
  {
    name: "ПІБ страхувальника:",
    context: ["name", "surname", "fatherName"],
    editable: true,
  },
  { name: "Термін підписки", context: ["termOfSubscription"], editable: true },
];

export const ThankYouPage = () => {
  const form = useForm({
    defaultValues: {
      phone: "+38 (",
    },
    mode: "onChange",
  });


  const {
    handleSubmit,
    reset,
    formState: { dirtyFields },
    setValue
  } = form;

  useEffect(() => {
    reset({
      checkBox1: true,
      accident_insurance_amount: { label: "90 000", value: "90000" },
      accident_insurance_currency: { label: "USD", value: "usd" },
      medical_assistance: { label: "50 000 EUR", value: "50000_eur" },
      liability_insurance_amount: { label: "40 000 EUR", value: "40000_eur" },
      proposalTableColumn: "standard",
    } as any);
  }, []);


  const onSubmit = handleSubmit((data: any) => {
    console.log(data);
    console.log('DIRTY', dirtyFields)
  });

  const getVariable = useContextStore((state) => state.getVariable);

  return (
    <>
      <br />
      <section>
        <Container className="mb-4 flex flex-col gap-4">
          <Stack className="flex flex-row gap-6 max-mdPlus:gap-0">
          </Stack>
        </Container>
        <Button onClick={() => {
          setValue('proposalTableColumn' as any, 'buisness')
        }}>Update context</Button>
        <Button onClick={onSubmit}>Submit</Button>
      </section>
      <br />     
    </>
  );
};
